import React, { ChangeEvent, FormEvent, useEffect, useState } from "react";
import {
  EpisodeInput,
  CreateEpisodeError,
} from "modules/video/components/DataType";
import { CreateEpisodeForm } from "modules/video/components/CreateFolderForm";
import { connect, useSelector } from "react-redux";
import { updateVideoEpisode } from "../store/action";
import { UpdateEpisodeInput, VideoEpisodeProps } from "../store/actionType";
import { ApiError } from "components";

interface EditEpisodeProps {
  closeModal: React.Dispatch<React.SetStateAction<boolean>>;
  episodeData: VideoEpisodeProps;
}
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = DispatchProps & EditEpisodeProps;

const EditEpisode: React.FC<Props> = ({
  closeModal,
  episodeData,
  onUpdateVideoEpisode,
}) => {
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [formData, setFormData] = useState<EpisodeInput>({
    label: episodeData.label || "",
    episode_number: episodeData.episode_number || 0,
  });
  const [error, setError] = useState<CreateEpisodeError>({});
  const [apiError, setApiError] = useState(null);
  const videoEpisodeState = useSelector(
    (state: any) => state.videoEpisodes?.genericVideoEpisodeState
  );

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value, type } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "number" ? Number(value) : value,
    }));
    setError((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };
  const handleSave = async (e: FormEvent) => {
    e.preventDefault();
    var input: UpdateEpisodeInput = {
      label: formData.label,
      episode_number: formData.episode_number,
      episode_id: episodeData.id,
      season_id: episodeData.season_id,
    };
    if (formData.label.trim() === "") {
      setError((prevErrors) => ({
        ...prevErrors,
        title: "Episode label is required",
      }));
    }
    if (formData.episode_number === 0) {
      setError((prevErrors) => ({
        ...prevErrors,
        order: "Episode number is required",
      }));
    }
    if (formData.label.trim() !== "" && formData.episode_number !== null) {
      setLoading(true);
      onUpdateVideoEpisode(input);
      setSubmitted(true);
      setLoading(false);
    }
  };
  useEffect(() => {
      if (!videoEpisodeState.isLoading && submitted) {
        if (videoEpisodeState.error) {
          setApiError(videoEpisodeState.error); // show error
        } else {
          setApiError(null);
          closeModal(false);
        }
      }
    }, [videoEpisodeState.isLoading, videoEpisodeState.error, submitted, closeModal]);
  return (
    <>
      <CreateEpisodeForm
        handleChange={handleChange}
        handleSubmit={handleSave}
        formData={formData}
        formErrors={error}
        loading={loading}
        header={"Update Episode"}
      />
        {apiError && <ApiError>{apiError}</ApiError>}
    </>
  );
};

const mapDispatchToProps = (dispatch: any) => ({
  onUpdateVideoEpisode: (input: UpdateEpisodeInput) =>
    dispatch(updateVideoEpisode(input)),
});

export default connect(null, mapDispatchToProps)(EditEpisode);
